interface ConfirmDeleteModalProps {
	isOpen: boolean;
	isBatchDelete: boolean;
	selectedCount?: number;
	isDeleting: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

export default function ConfirmDeleteModal(props: ConfirmDeleteModalProps) {
	const { isOpen, isBatchDelete, selectedCount = 0, isDeleting, onConfirm, onCancel } = props;

	if (!isOpen) return null;

	const handleBackdropClick = (e: React.MouseEvent) => {
		if (e.target === e.currentTarget && !isDeleting) {
			onCancel();
		}
	};

	return (
		<div className="confirm-delete-modal-backdrop" onClick={handleBackdropClick}>
			<div className="confirm-delete-modal-container">
				<div className="confirm-delete-modal-header">
					<h4 className="confirm-delete-modal-title">
						<i
							className="fas fa-exclamation-triangle"
							style={{ color: '#dc3545', marginRight: '0.5rem' }}
						></i>
						Confirm Delete
					</h4>
				</div>

				<div className="confirm-delete-modal-content">
					<p className="confirm-delete-modal-message">
						{isBatchDelete
							? `Are you sure you want to delete ${selectedCount} photo${selectedCount !== 1 ? 's' : ''}?`
							: 'Are you sure you want to delete this photo?'}
					</p>
					<p className="confirm-delete-modal-warning">This action cannot be undone.</p>
				</div>

				<div className="confirm-delete-modal-actions">
					<button className="btn btn-default" onClick={onCancel} disabled={isDeleting}>
						Cancel
					</button>
					<button className="btn btn-danger" onClick={onConfirm} disabled={isDeleting}>
						{isDeleting ? (
							<>
								<i className="fas fa-spinner fa-spin" style={{ marginRight: '0.5rem' }}></i>
								Deleting...
							</>
						) : (
							<>
								<i className="fas fa-trash" style={{ marginRight: '0.5rem' }}></i>
								Delete
							</>
						)}
					</button>
				</div>
			</div>
		</div>
	);
}
